var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List",
    clipPath: "url(#clip0_23_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.59555 8.63453C0.715754 8.63453 0 7.91878 0 7.03898C0 6.15918 0.715754 5.44343 1.59555 5.44343C2.47535 5.44343 3.19111 6.15918 3.19111 7.03898C3.19111 7.91878 2.47535 8.63453 1.59555 8.63453ZM1.59555 6.52516C1.31222 6.52516 1.08173 6.75565 1.08173 7.03898C1.08173 7.32231 1.31222 7.5528 1.59555 7.5528C1.87889 7.5528 2.10938 7.32231 2.10938 7.03898C2.10938 6.75565 1.87889 6.52516 1.59555 6.52516ZM1.59555 13.9621C0.715754 13.9621 0 13.2463 0 12.3665C0 11.4867 0.715754 10.771 1.59555 10.771C2.47535 10.771 3.19111 11.4867 3.19111 12.3665C3.19111 13.2463 2.47535 13.9621 1.59555 13.9621ZM1.59555 11.8527C1.31222 11.8527 1.08173 12.0832 1.08173 12.3665C1.08173 12.6498 1.31222 12.8803 1.59555 12.8803C1.87889 12.8803 2.10938 12.6498 2.10938 12.3665C2.10938 12.0832 1.87889 11.8527 1.59555 11.8527ZM1.59555 3.30701C0.715754 3.30701 0 2.59126 0 1.71146C0 0.83166 0.715754 0.115906 1.59555 0.115906C2.47535 0.115906 3.19111 0.83166 3.19111 1.71146C3.19111 2.59126 2.47535 3.30701 1.59555 3.30701ZM1.59555 1.19764C1.31222 1.19764 1.08173 1.42813 1.08173 1.71146C1.08173 1.99479 1.31222 2.22528 1.59555 2.22528C1.87889 2.22528 2.10938 1.99479 2.10938 1.71146C2.10938 1.42813 1.87889 1.19764 1.59555 1.19764ZM13.8462 6.49812H4.38101V7.57985H13.8462V6.49812ZM13.8462 1.17059H4.38101V2.25232H13.8462V1.17059ZM13.8462 11.8256H4.38101V12.9074H13.8462V11.8256Z",
    fill: "url(#paint0_linear_23_1749)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_1749",
    x1: 6.92308,
    y1: 0.115906,
    x2: 6.92308,
    y2: 13.9621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFAF0A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8462,
    height: 13.8462,
    fill: "white",
    transform: "translate(0 0.115906)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.1d39b63f8f43c840b2f958578aef0c39.svg";
export { ForwardRef as ReactComponent };